import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
 import Button from'../ui/Button';
 import Input from'../ui/Input';

const Login = () => {
  const { signIn } = useAuth()
  const navigate = useNavigate()
  const [formData, setFormData] = useState({ email: '', password: '' })
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const handleSubmit = async (e) => {
    e?.preventDefault()
    setLoading(true)
    setError(null)

    const { user, error: signInError } = await signIn(formData?.email, formData?.password)
    
    if (signInError) {
      setError(signInError)
    } else if (user) {
      navigate('/dashboard')
    }
    
    setLoading(false)
  }

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e?.target?.name]: e?.target?.value
    }))
    // Clear error when user starts typing
    if (error) setError(null)
  }

  const handleDemoLogin = async (email, password) => {
    setFormData({ email, password })
    setLoading(true)
    setError(null)
    
    const { user, error: signInError } = await signIn(email, password)
    
    if (signInError) {
      setError(signInError)
    } else if (user) {
      navigate('/dashboard')
    }
    
    setLoading(false)
  }

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Anmeldung bei AdvoCall
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Melden Sie sich an, um Ihre Anfragen zu verwalten
          </p>
        </div>
        
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <div className="space-y-4">
            <Input
              label="E-Mail-Adresse"
              type="email"
              name="email"
              value={formData?.email}
              onChange={handleChange}
              required
              placeholder="ihre.email@beispiel.de"
              error={error && error.includes('email') ? error : null}
            />

            <Input
              label="Passwort"
              type="password"
              name="password"
              value={formData?.password}
              onChange={handleChange}
              required
              placeholder="Ihr Passwort"
              error={error && !error.includes('email') ? error : null}
            />
          </div>

          {error && (
            <div className="bg-red-50 border border-red-200 rounded-md p-4">
              <div className="flex">
                <div className="text-sm text-red-700">
                  {error}
                </div>
              </div>
            </div>
          )}

          <div>
            <Button
              type="submit"
              variant="default"
              size="lg"
              loading={loading}
              className="w-full bg-trust-builder hover:bg-trust-builder/90 text-white"
            >
              {loading ? 'Wird angemeldet...' : 'Anmelden'}
            </Button>
          </div>
        </form>

        {/* Demo Credentials Section */}
        <div className="mt-8 p-4 bg-gray-50 rounded-lg border border-gray-200">
          <h3 className="text-sm font-medium text-gray-700 mb-3">Demo-Zugangsdaten:</h3>
          <div className="space-y-2 text-xs text-gray-600">
            <div className="flex justify-between items-center p-2 bg-white rounded border">
              <span><strong>Admin:</strong> admin@advocall.de / admin123</span>
              <button
                type="button"
                onClick={() => handleDemoLogin('admin@advocall.de', 'admin123')}
                className="text-primary hover:text-primary/80 font-medium"
                disabled={loading}
              >
                Anmelden
              </button>
            </div>
            <div className="flex justify-between items-center p-2 bg-white rounded border">
              <span><strong>Anwalt:</strong> lawyer@advocall.de / lawyer123</span>
              <button
                type="button"
                onClick={() => handleDemoLogin('lawyer@advocall.de', 'lawyer123')}
                className="text-primary hover:text-primary/80 font-medium"
                disabled={loading}
              >
                Anmelden
              </button>
            </div>
            <div className="flex justify-between items-center p-2 bg-white rounded border">
              <span><strong>Kunde:</strong> user@advocall.de / user123</span>
              <button
                type="button"
                onClick={() => handleDemoLogin('user@advocall.de', 'user123')}
                className="text-primary hover:text-primary/80 font-medium"
                disabled={loading}
              >
                Anmelden
              </button>
            </div>
          </div>
        </div>

        <div className="text-center">
          <p className="text-sm text-gray-600">
            Noch kein Konto?{' '}
            <button
              type="button"
              onClick={() => navigate('/signup')}
              className="font-medium text-primary hover:text-primary/80"
            >
              Hier registrieren
            </button>
          </p>
        </div>
      </div>
    </div>
  )
}

export default Login